var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C15.52 3 18.38 5.86 18.38 9.38C18.38 11.5 17.32 13.48 15.55 14.67C14.87 15.13 14.46 15.89 14.46 16.7V17.76C14.46 17.89 14.35 18 14.22 18H9.76002C9.63002 18 9.52002 17.89 9.52002 17.76V16.7C9.52002 15.88 9.11002 15.12 8.43002 14.67C6.31002 13.24 5.26001 10.77 5.70001 8.23C6.14001 5.71 8.18002 3.61 10.68 3.13C11.13 3.04 11.57 3 12 3ZM12 1C11.45 1 10.89 1.05 10.32 1.16C6.98002 1.81 4.33002 4.54 3.75002 7.89C3.14002 11.39 4.72002 14.57 7.33001 16.33C7.46001 16.42 7.53002 16.55 7.53002 16.71V17.77C7.53002 19 8.53002 20.01 9.77002 20.01H14.24C15.47 20.01 16.48 19.01 16.48 17.77V16.71C16.48 16.56 16.56 16.42 16.68 16.33C18.91 14.82 20.39 12.28 20.39 9.38C20.38 4.75 16.63 1 12 1Z",
    fill: "#5784EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H10C9.45 23 9 22.55 9 22C9 21.45 9.45 21 10 21H14C14.55 21 15 21.45 15 22C15 22.55 14.55 23 14 23Z",
    fill: "#5784EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/Patients.62c5820c42ea8b96148c7f1bdd729d50.svg";
export { ForwardRef as ReactComponent };